import Card from "components/card";
import React, { useMemo,useState } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { MdOutlineDeleteForever } from "react-icons/md";
import { MdOutlineSettings } from "react-icons/md";
import { FaRegWindowClose } from "react-icons/fa";
import { API_BASE_URL } from '../../../../configs/AppConfig';
import api from "views/auth/Api";
import { message } from 'antd';


const ModelsTable = (props) => {
  const { columnsData, tableData, deleted, edited,selectPlate } = props;
  // console.log(columnsData,tableData,"tableData")
  const [delOpen , setDelOpen] = useState(false)
  const [plateId, setPlateId] = useState(null);
  const [selected, setSelected] = useState(null);
  // const [editedId, setEditedId] = useState(null);
  
  const columns = useMemo(() => columnsData, [columnsData]);
  const data = useMemo(() => tableData, [tableData]);

  const delSuccess = ()=>{
    message.success('Delete done');
  }

  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    initialState,
  } = tableInstance;
  initialState.pageSize = 50;
 
  
 const editRow =(id)=>{
    edited(id)
 }

 const delRow =(id)=>{
  console.log(id,"row.original.id")
  setDelOpen(true)
  setPlateId(id)
 }

 const confirmDel =(plateId)=>{
    if (plateId) {
      setDelOpen(false)
     api.delete(`${API_BASE_URL}parts-3dmodel/${plateId}`)
      .then(function (response) {
          deleted(response.data);
          delSuccess();
      }).catch(error => {
        console.log("handlesubmit error for blog ", error)
      });
  }
 }
  const handleChange = (value) => {
    setSelected(value === selected ? null : value);
    selectPlate(value === selected ? null : value);
  };


  return (
    <Card extra={"w-full pb-10 p-4 h-full"}>
      <div className="mt-2 overflow-x-scroll xl:overflow-x-hidden">
        <table {...getTableProps()} className="w-full">
          <thead>
            {headerGroups.map((headerGroup, index) => (
              <tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {headerGroup.headers.map((column, index) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    key={index}
                    className="border-b border-gray-200 pr-14 pb-[10px] text-start dark:!border-navy-700"
                  >
                    <div className="flex w-full justify-between pr-10 text-xs tracking-wide text-gray-600">
                      {column.render("Header")}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row, index) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} key={index}>
                  {row.cells.map((cell, index) => {
                    let data;
                    if (cell.column.Header === "MODEL NAME") {
                      data = (
                        <p className="text-sm font-bold text-navy-700 dark:text-white capitalize">
                          {cell.value}
                        </p>
                      );
                    } else if (cell.column.Header === "BUILD PLATES") {
                      data = (
                        <p className="mr-[10px] text-sm font-semibold text-navy-700 dark:text-white capitalize">
                          {cell.value}
                        </p>
                      );
                    } else if (cell.column.Header === "PARTS WEIGHT") {
                      data = (
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          {cell.value} G
                        </p>
                      );
                    } else if (cell.column.Header === "RECOMMEND MATERIAL") {
                      data = (
                        <p className="text-sm font-bold text-navy-700 dark:text-white capitalize">
                          {cell.value}
                        </p>
                      );
                    } else if (cell.column.Header === "AVERAGE PRINT DURATION") {
                      data = (
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          {cell.value} 
                        </p>
                      );
                    } else if (cell.column.Header === "PARTS QUANTITY") {
                      data = (
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          {cell.value}
                        </p>
                      );
                    } else if (cell.column.Header === "SELECT") {
                      data = (
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          <input type="checkbox" onChange={() => handleChange(row.original.id)} checked={selected === row.original.id} className="checkTD" />
                        </p>
                      );
                    }
                    else if (cell.column.Header === "ACTION") {
                      data = (
                        <div className=" font-bold text-navy-700 dark:text-white flex ">
                          <MdOutlineSettings className="editIcons mr-[10px]" onClick={()=> {editRow(row.original.id)}}/> 
                          <MdOutlineDeleteForever className="editIcons" onClick={()=> {delRow(row.original.id)}}/>
                        </div>
                      );
                    }
                    return (
                      <td
                        className="pt-[14px] sm:text-[14px]"
                        {...cell.getCellProps()}
                        key={index}
                      >
                        {data}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      { delOpen ? <div className="modal"> <div id="delPopup">
    <button id="popIcon" onClick={()=>{setDelOpen(false)}}>
    <FaRegWindowClose className="w-full h-full	"/>
  </button>
  <div id="helpText"><span >Do you want to delete this one?</span></div>
  <div id="yesno">
  <button className="yesorno" onClick={() => {confirmDel(plateId)}}> Yes </button>
  <button className="yesorno" onClick={()=>{setDelOpen(false)}}> No </button> 
  </div>
    </div></div> : null}
    </Card>
  );
};

export default ModelsTable;
